import DashboardLayout from "@/layout/dashboard/DashboardLayout.vue";

// GeneralViews
import NotFound from "@/pages/NotFoundPage.vue";

// Admin pages
import Product from "@/pages/Product.vue"

const routes = [
    {
        path: "/",
        component: DashboardLayout,
        redirect: "",
        children: [
            {
                path: "/",
                name: "",
                component: Product
            },
           
        ]
    },
    { path: "*", component: NotFound }
];

export default routes;
